import { Mail, BookOpen } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { facultyAdvisors } from '../mock/data';

export const Advisors = () => {
  return (
    <section id="advisors" className="py-24 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
            Faculty Advisors
          </h2>
          <div className="w-24 h-1 bg-[#BB0000] mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Distinguished faculty members guiding our mission and supporting student success
          </p>
        </div>

        {/* Advisors Grid */}
        <div className="grid md:grid-cols-2 gap-8 mb-8">
          {facultyAdvisors.map((advisor) => (
            <Card 
              key={advisor.id} 
              className="border-2 border-gray-200 hover:border-[#BB0000] transition-all group bg-white overflow-hidden shadow-lg"
            >
              <CardContent className="p-8">
                <div className="flex flex-col items-center text-center">
                  <div className="relative w-32 h-32 mb-6">
                    <div className="absolute inset-0 bg-[#BB0000]/20 rounded-full blur-xl group-hover:blur-2xl transition-all"></div>
                    <img 
                      src={advisor.image} 
                      alt={advisor.name}
                      className="relative w-full h-full object-cover rounded-full border-4 border-white shadow-lg"
                    />
                  </div>
                  
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">{advisor.name}</h3>
                  <p className="text-[#BB0000] font-semibold mb-1">{advisor.title}</p>
                  <p className="text-sm text-gray-600 mb-4">{advisor.department}</p>
                  
                  <div className="flex items-center gap-2 text-sm text-gray-700 mb-6 bg-gray-50 px-4 py-2 rounded-lg">
                    <BookOpen size={16} className="text-[#BB0000] flex-shrink-0" />
                    <span className="font-medium text-center">{advisor.specialty}</span>
                  </div>

                  <a 
                    href={`mailto:${advisor.email}`}
                    className="inline-flex items-center gap-2 px-4 py-2 bg-gray-100 hover:bg-[#BB0000] text-gray-700 hover:text-white rounded-lg transition-colors font-medium"
                  >
                    <Mail size={18} />
                    <span className="text-sm">Contact</span>
                  </a>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Bio Sections - Collapsible */}
        <div className="space-y-4 max-w-4xl mx-auto">
          {facultyAdvisors.map((advisor) => (
            <Accordion key={advisor.id} type="single" collapsible>
              <AccordionItem 
                value={`bio-${advisor.id}`}
                className="bg-white border-2 border-gray-200 rounded-lg overflow-hidden hover:border-[#BB0000] transition-colors"
              >
                <AccordionTrigger className="px-6 py-4 hover:no-underline">
                  <div className="text-left">
                    <h4 className="text-lg font-bold text-gray-900">About {advisor.name}</h4>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-6">
                  <p className="text-gray-700 leading-relaxed">
                    {advisor.bio}
                  </p>
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          ))}
        </div>
      </div>
    </section>
  );
};
